import { makeStyles } from "@material-ui/core";

export default makeStyles({
	dialog: {
		maxWidth: "464px",
		flexGrow: 0,
		padding: "32px 0 40px",
		borderRadius: "4px",
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		backgroundColor: "#ffffff",
	},
	logo: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		margin: "0 172px 31.5px",
		flexGrow: 0,
	},
	divider: {
		width: "100%",
		height: "1px",
		flexGrow: 0,
		margin: "31.5px 0 23.5px",
		backgroundColor: "#cddcdc",
	},
	codeAndHeaderBox: {
		flexGrow: 0,
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		gap: "12px",
		padding: 0,
	},
	statusCode: {
		flexGrow: 0,
		fontFamily: "Nunito",
		fontSize: "29px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.15,
		letterSpacing: "normal",
		textAlign: "center",
		color: "#5e6e7d",
	},
	header: {
		flexGrow: 0,
		fontFamily: "Nunito",
		fontSize: "29px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.15,
		letterSpacing: "normal",
		textAlign: "center",
		color: "#212121",
	},
	banner: {
		//width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		flexGrow: 0,
		gap: "10px",
		margin: "16px 0 0",
		padding: "24px",
		backgroundColor: "#f5f8f9"
	},
	description: {
		flexGrow: 0,
		fontFamily: "Nunito",
		fontSize: "18px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.3,
		letterSpacing: "normal",
		textAlign: "center",
		color: "#212121",
	},
	buttonBox: {
		flexGrow: 0,
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		marginTop: "32px",
	},
	button: {
		flexGrow: 0,
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		gap: "10px",
		margin: "32px 157px 0 158px",
		padding: "8px 16px",
		borderRadius: "2px",
		backgroundColor: "#367bf5",
		'& .MuiButton-contained': {
			padding: "8px 16px",
		},
	},
	buttonText: {
		height: "21px",
		flexGrow: 0,
		fontFamily: "Nunito",
		fontSize: "12px",
		fontWeight: "bold",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.75,
		letterSpacing: "normal",
		textAlign: "center",
		color: "#ffffff",
		textTransform: "uppercase",
	}
});
